import { render } from "./Organogram.vue?vue&type=template&id=dea67ebe&scoped=true"
import script from "./Organogram.vue?vue&type=script&lang=js"
export * from "./Organogram.vue?vue&type=script&lang=js"

import "./Organogram.vue?vue&type=style&index=0&id=dea67ebe&lang=scss&scoped=true"

import exportComponent from "/media/dolar/office/office_project/oneGov-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dea67ebe"]])

export default __exports__